import { Box, Stack, Avatar, Typography } from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';

type Props = {
  name: string;
  avatarUrl: string | null;
  address: string | null;
  mapsUrl: string | null;
};

const ProfileHero = ({ name, avatarUrl, address, mapsUrl }: Props) => (
  <Box
    sx={{
      position: 'relative',
      pt: 6,
      pb: 5,
      px: 2,
      textAlign: 'center',
      overflow: 'hidden',
      minHeight: 260,
    }}
  >
    {/* Pozadí — mapa nebo gradient */}
    {address ? (
      <Box sx={{ position: 'absolute', inset: 0, zIndex: 0, pointerEvents: 'none' }}>
        <iframe
          title="Mapa pozadí"
          width="100%"
          height="100%"
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          src={`https://maps.google.com/maps?q=${encodeURIComponent(address)}&output=embed&hl=cs&z=15`}
        />
      </Box>
    ) : (
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          zIndex: 0,
          background: 'linear-gradient(135deg, #D02964 0%, #e33f5c 100%)',
        }}
      />
    )}

    {/* Tmavý overlay */}
    <Box
      sx={{
        position: 'absolute',
        inset: 0,
        zIndex: 1,
        background: 'linear-gradient(to bottom, rgba(0,0,0,0.55) 0%, rgba(30,10,20,0.72) 100%)',
      }}
    />

    {/* Obsah */}
    <Box sx={{ position: 'relative', zIndex: 2 }}>
      <Avatar
        src={avatarUrl ?? undefined}
        alt={name}
        sx={{
          width: 100,
          height: 100,
          mx: 'auto',
          mb: 2,
          border: '3px solid rgba(255,255,255,0.9)',
          boxShadow: '0 4px 20px rgba(0,0,0,0.35)',
          fontSize: '2.5rem',
          bgcolor: 'rgba(255,255,255,0.2)',
          color: '#fff',
        }}
      >
        {name.charAt(0).toUpperCase()}
      </Avatar>

      <Typography
        variant="h5"
        sx={{
          color: '#fff',
          fontWeight: 700,
          mb: 0.5,
          letterSpacing: 0.3,
          textShadow: '0 1px 4px rgba(0,0,0,0.4)',
        }}
      >
        {name}
      </Typography>

      {address && (
        <Stack
          direction="row"
          spacing={0.5}
          justifyContent="center"
          alignItems="center"
          sx={{ mt: 1 }}
        >
          <LocationOnIcon sx={{ color: 'rgba(255,255,255,0.9)', fontSize: 16 }} />
          <Typography
            variant="body2"
            sx={{
              color: 'rgba(255,255,255,0.9)',
              fontSize: '0.8rem',
              cursor: mapsUrl ? 'pointer' : 'default',
              textDecoration: mapsUrl ? 'underline' : 'none',
              textShadow: '0 1px 3px rgba(0,0,0,0.4)',
            }}
            onClick={() => mapsUrl && window.open(mapsUrl, '_blank', 'noopener,noreferrer')}
          >
            {address}
          </Typography>
        </Stack>
      )}
    </Box>
  </Box>
);

export default ProfileHero;
